import { diwaliOfficialRules2026, diwalitermscondition } from "../../../helpers/constant-words";
import "./diwaliFooter.scss";
import { NavLink } from "react-router-dom";
import fbicon from "../../../images/Diwali-2025/facebook_icon.svg";
import instaicon from "../../../images/Diwali-2025/insta_icon.svg";
import youtubeicon from "../../../images/Diwali-2025/yt_icon.svg";
import linkedinicon from "../../../images/Diwali-2025/linkedin_icon.svg";
import tikTokIcon from "../../../images/Diwali-26/tik_tok_icon.svg";

const DiwaliFooter = () => {
  const year = new Date();

  return (
    <>
      <footer className="diwali_footersec1_2026">
        <div className="my_container">
          <div className="text_container">
            <NavLink to={diwaliOfficialRules2026} className="footer_text">
              OFFICIAL RULES
            </NavLink>

            <div className="social_icons">
              <a
                href="https://www.instagram.com/laxmifoodsbrand/?hl=en"
                target="_blank"
                className="social_link"
              >
                <img
                  src={instaicon}
                  alt="social media icon"
                  width={40}
                  height={40}
                  loading="lazy"
                  className="social_icon"
                />
              </a>
              <a
                href="https://www.facebook.com/LaxmiFoodsBrand/"
                target="_blank"
                className="social_link"
              >
                <img
                  src={fbicon}
                  alt="social media icon"
                  width={40}
                  height={40}
                  loading="lazy"
                  className="social_icon"
                />
              </a>
              <a
                href="https://www.youtube.com/channel/UCA-ojVe3STlOlTOzGzZhYwQ/featured"
                target="_blank"
                className="social_link"
              >
                <img
                  src={youtubeicon}
                  alt="social media icon"
                  width={40}
                  height={40}
                  loading="lazy"
                  className="social_icon"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/houseofspices"
                target="_blank"
                className="social_link"
              >
                <img
                  src={linkedinicon}
                  alt="social media icon"
                  width={40}
                  height={40}
                  loading="lazy"
                  className="social_icon"
                />
              </a>
              <a href="https://www.tiktok.com/@laxmifoodsbrand " target="_blank" className="social_link">
                <img
                  src={tikTokIcon}
                  alt="social media icon"
                  width={40}
                  height={40}
                  loading="lazy"
                  className="social_icon"
                />
              </a>
            </div>

            <p className="footer_text">
              © {year.getFullYear()} Laxmi. All Rights Reserved.{" "}
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default DiwaliFooter;
